import BaseComponent from 'scripts/BaseComponent.js';

export default class CollectionHatboxGrid extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      shapeContainer: '.js-hatboxShapeContainer',
    };

    this.dom = {
      $component: component,
      $shapeContainers: this.$getAll(this.refs.shapeContainer),
    };

    this.state = {
      updateHatboxNavEvent: 'updatehatboxnav',
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.observe();
  }

  observe() {
    const { dom } = this;

    const observer = new IntersectionObserver(
      this.onIntersection.bind(this),
      { threshold: 0.5 },
    );

    dom.$shapeContainers.forEach((elem) => observer.observe(elem));
  }

  onIntersection([entry]) {
    if (!entry.isIntersecting) return;
    const { state: { updateHatboxNavEvent } } = this;
    const { shape, index } = entry.target.dataset;

    this.dispatch(updateHatboxNavEvent, { shape, index });
  }
}
